;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.2";import { captureRouterTransitionStart, init } from '@sentry/nextjs'

export const onRouterTransitionStart = captureRouterTransitionStart

init({
    dsn:
        process.env.SENTRY_DSN ||
        process.env.NEXT_PUBLIC_SENTRY_DSN ||
        'https://0fc46714158f4013a00aa49cf1f937ab@o476415.ingest.sentry.io/5530229',
    tracesSampleRate: 0,
    enabled: process.env.NODE_ENV === 'production',
})
